import React, { useState } from "react";

/**
 * MobileTipsTooltip - Displays helpful tips for mobile users
 */
const MobileTipsTooltip = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    // Store in localStorage to avoid showing it again in the same session
    localStorage.setItem("mobile-tips-dismissed", "true");
  };

  return (
    <div
      className={`fixed bottom-4 right-4 bg-[#1a1e21] text-white rounded-lg shadow-lg p-4 w-64 z-50 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="flex justify-between items-start mb-2">
        <h3 className="font-medium">Mobile Tips:</h3>
        <button
          onClick={handleClose}
          className="text-gray-400 hover:text-white"
          aria-label="Close tips"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <ul className="list-disc pl-5 text-sm space-y-1">
        <li>Long-press a task to drag it</li>
        <li>Tap a task to edit it</li>
        <li>Scroll sideways to see all columns</li>
      </ul>
      <div className="mt-2 text-right">
        <button
          onClick={handleClose}
          className="text-xs text-[#4db1e0] hover:underline"
        >
          View all shortcuts
        </button>
      </div>
    </div>
  );
};

export default MobileTipsTooltip;
